import { createContext } from "react";

export interface GlobalSearchContextValue {
  isOpen: boolean;
  searchQuery: string;
  openSearch: (query?: string) => void;
  closeSearch: () => void;
  toggleSearch: () => void;
  setSearchQuery: (q: string) => void;
}

export const GlobalSearchContext = createContext<GlobalSearchContextValue>({
  isOpen: false,
  searchQuery: "",
  openSearch: () => {},
  closeSearch: () => {},
  toggleSearch: () => {},
  setSearchQuery: () => {},
});
